import React from "react";
import "./AuthLoading.css";

export default function AuthLoading({ message = "Autenticando acesso..." }) {
  return (
    <div className="auth-loading-overlay">
      <div className="auth-loading-card">
        <div className="auth-loading-accent" />

        <div className="auth-loading-main">
          <div className="auth-loading-spinner-wrapper">
            <div className="auth-loading-spinner" />
          </div>
          <div className="auth-loading-texts">
            <h2>Um instante…</h2>
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
